import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telephone'
})
export class DisplayTelephonePipe implements PipeTransform {
  private ds = '-';

  transform(value: string, args?: any): any {
    let tel = value;
    if (value && value.length == 10) {
      tel = value.substring(0, 3);
      tel += this.ds;
      tel += value.substring(3, 6);
      tel += this.ds;
      tel += value.substring(6);
    }
    return tel;
  }

}
